"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomainDynamoMapper = void 0;
const dynamodb_mapper_1 = require("../dynamodb-mapper");
const domain_json_1 = require("./domain-json");
exports.DomainDynamoMapper = (0, dynamodb_mapper_1.createDynamoMapper)('Domain', domain_json_1.DomainJsonMapper);
